module.exports = __webpack_public_path__ + "img/Air cleaner.81b6d78b.jpg";